/* ═══════════════════════════════════════════════════════════════════════════
   Сообщество Timbrica — клиент доски.

   ⚠️ Форма сообщения — КОНТРАКТ с `CommunityBoard::presentMessage()`. Меняешь
   поле там — правь здесь в том же коммите: лента опустеет молча, страница
   отдаст 200 без единой ошибки.

   ⛔ innerHTML с пользовательским текстом не встречается НИГДЕ. Всё, что писал
   человек, попадает в DOM только через textContent, а ссылки и упоминания
   собираются createElement. Это не стиль: доска закрытая, но её читают
   полторы тысячи оплаченных аккаунтов, и один <img onerror> в реплике — это
   их сессии.

   Новые возможности браузеров применяются там, где они дают выигрыш, и всегда
   с запасным путём — старый браузер обязан получить рабочую доску, а не
   пустой экран:
     field-sizing:content   → поле растёт само (иначе JS-автоподгон ниже)
     navigator.locks        → опрашивает ОДНА вкладка из многих (иначе опрашивает своя)
     BroadcastChannel       → остальные вкладки получают ту же выдачу даром
     Popover API            → палитра эмодзи в верхнем слое (иначе абсолютный блок)
     Intl.RelativeTimeFormat→ «5 минут назад» на 10 локалях (иначе часы:минуты)
     content-visibility     → строки вне окна не раскладываются (CSS, сам по себе)
     @starting-style        → появление новой реплики (CSS, сам по себе)
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
    'use strict';

    var root = document.getElementById('cmBoard');
    var rulesDlg = document.getElementById('cmRules');

    // Кнопка «правила» живёт и на экране отказа, где доски нет вовсе.
    document.querySelectorAll('[data-cm-rules]').forEach(function (b) {
        b.addEventListener('click', function () { openRules(); });
    });
    // Закрыть можно и кнопкой в подвале, и крестиком в шапке, и Esc. Крестик
    // добавили в разметку раньше, чем сюда, — и он молча ничего не делал:
    // кнопка, которая выглядит рабочей и не работает, хуже её отсутствия.
    ['cmRulesClose', 'cmRulesX'].forEach(function (id) {
        var b = document.getElementById(id);
        if (b) b.addEventListener('click', function () { closeRules(); });
    });

    function openRules() { if (rulesDlg) { try { rulesDlg.showModal(); } catch (e) { rulesDlg.setAttribute('open', ''); } } }
    function closeRules() { if (rulesDlg) { try { rulesDlg.close(); } catch (e) { rulesDlg.removeAttribute('open'); } } }

    if (!root) return; // экран отказа — дальше нечего оживлять

    var EP = JSON.parse(root.dataset.endpoints);
    var CFG = JSON.parse(root.dataset.cfg);
    var T = JSON.parse(root.dataset.i18n);

    var listEl = document.getElementById('cmList');
    var inputEl = document.getElementById('cmInput');
    var sendBtn = document.getElementById('cmSend');
    var countEl = document.getElementById('cmCount');
    var hintEl = document.getElementById('cmHint');
    var jumpBtn = document.getElementById('cmJump');
    var replyBar = document.getElementById('cmReply');
    var replyTxt = document.getElementById('cmReplyT');
    var ideasEl = document.getElementById('cmIdeas');
    var ideaCountEl = document.getElementById('cmIdeaCount');
    var ideasHint = document.getElementById('cmIdeasHint');
    var ideaFilterEl = document.getElementById('cmIdeaFilter');
    var whoBtn = document.getElementById('cmWhoBtn');
    var whoNEl = document.getElementById('cmWhoN');
    var stackEl = document.getElementById('cmStack');
    var whoDlg = document.getElementById('cmWhoDlg');
    var peopleEl = document.getElementById('cmPeople');
    var tagsEl = document.getElementById('cmTags');
    var typingEl = document.getElementById('cmTyping');
    var gripEl = document.getElementById('cmGrip');
    var pinEl = document.getElementById('cmPin');
    var pinBody = document.getElementById('cmPinBody');
    var emojiBar = document.getElementById('cmEmojiBar');
    var emojiGrid = document.getElementById('cmEmojiG');
    var emojiBtn = document.getElementById('cmEmoji');
    var fileInput = document.getElementById('cmFile');
    var previewBox = document.getElementById('cmPreview');
    var previewImg = document.getElementById('cmPreviewImg');
    var lightbox = document.getElementById('cmLightbox');
    var lightboxImg = document.getElementById('cmLightboxImg');

    var state = {
        lastId: 0,
        firstId: 0,
        hasMore: false,
        atBottom: true,
        unseen: 0,
        replyTo: null,
        editing: null,
        file: null,
        ideaFilter: 'open',
        rulesOk: !!CFG.rulesOk,
        lastAuthor: null,
        lastTs: 0,
        lastDay: '',
        loading: false,
        // Граница «отсюда новое». Приходит ДО того, как отметка о прочтении
        // обновится, — иначе черта не успевает появиться ни разу.
        lastRead: 0,
        firstPaint: true,
        members: [],
        interests: [],
        typingAt: 0,
        // Лента занята результатами поиска — опрос в неё не дописывает.
        searching: false
    };

    /*
     | Значки собираются из кодов, а не пишутся символами.
     |
     | ⚠️ Это не вкус: файл читают и правят из редакторов с разной кодировкой,
     | и один битый байт в эмодзи превращает кнопку в знак замены U+FFFD.
     | Коды переживают любой конвейер.
     |
     | ⚠️ Сам этот комментарий — тот же урок с обратной стороны: знак замены,
     | написанный здесь БУКВАЛЬНО ради примера, уронил полный суит на
     | `SourceTextIsNotBrokenTest`. В исходнике его называют кодом, а не рисуют.
     |
     | Подписи к значкам — всегда из переводов: значок не имеет права остаться
     | единственным носителем смысла, экранный диктор читает aria-label.
     */
    var PENCIL      = '✎';   // ✎ правлено
    var CLOCK       = '○';   // ○ отправляется
    var CHECK       = '✓';   // ✓ ушло
    var WARN        = '⚠';   // ⚠ не ушло
    var IDEA_ICON   = '💡';
    var UP_ARROW    = '▲';
    var RIGHT_ARROW = '→';
    var TOOLBOX     = '🧰';

    // ────────────────────────────────────────────────────────── утилиты ──

    function csrf() {
        var m = document.querySelector('meta[name="csrf-token"]');
        return m ? m.getAttribute('content') : '';
    }

    /**
     * Хвост запроса, называющий доску.
     *
     * ⚠️ Доска = локаль, и маршруты /api/community/* locale-free: если её не
     * назвать, сервер возьмёт локаль приложения — на API-запросе это может
     * быть не та доска, которую человек читает. Сервер значение ПРОВЕРЯЕТ, но
     * назвать его — работа страницы.
     */
    function boardQ(sep) {
        return sep + 'board=' + encodeURIComponent(CFG.board || CFG.locale || '');
    }

    function post(url, body, isForm) {
        var opts = {
            method: 'POST',
            headers: { 'X-CSRF-TOKEN': csrf(), 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            credentials: 'same-origin'
        };
        if (isForm) {
            body.append('board', CFG.board || CFG.locale || '');
            opts.body = body;
        } else {
            opts.headers['Content-Type'] = 'application/json';
            body = body || {};
            body.board = CFG.board || CFG.locale || '';
            opts.body = JSON.stringify(body);
        }
        // AbortSignal.timeout: запрос, который висит минуту, для доски мёртв —
        // человек уже нажал ещё раз.
        if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) opts.signal = AbortSignal.timeout(20000);
        return fetch(url, opts).then(function (r) {
            return r.json().catch(function () { return { ok: false, reason: 'bad_json' }; });
        });
    }

    function get(url) {
        var opts = {
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
            credentials: 'same-origin'
        };
        if (typeof AbortSignal !== 'undefined' && AbortSignal.timeout) opts.signal = AbortSignal.timeout(20000);
        return fetch(url, opts).then(function (r) { return r.json(); });
    }

    /*
     | ────────────────────────────────────────────────────────── приборы ──
     |
     | ⚠️⚠️ До 18.09.2026 доска не отправляла НИ ОДНОГО события. Это не
     | забывчивость, а причина, по которой её дефекты жили неделями: каждое
     | вложение отвечало 400 с первого дня публикации, и узнать об этом было
     | неоткуда — картинку грузит браузер, а не наш код, поэтому её отказ не
     | видит ни `tool_errors`, ни что-либо ещё. Нашлось глазами на скриншоте.
     |
     | Меряем ровно то, чего не видно снаружи: дошло ли вложение, чем кончилась
     | отправка, пользуются ли поиском, на каком экране читают. Содержимое
     | реплик НЕ отправляется никуда и ни в каком виде — только длины и коды
     | причин: доска закрытая, и прибор не имеет права стать вторым каналом,
     | по которому её содержание утекает.
     */
    function funnel(stage, data) {
        try {
            if (window.__aeFunnel) window.__aeFunnel(stage, data || {});
        } catch (e) { /* прибор никогда не ломает доску */ }
    }

    function stage(name, meta) {
        try {
            if (window.__stage) window.__stage(name, meta || {});
        } catch (e) { /* то же самое */ }
    }

    /**
     * Вложение не открылось у ЧИТАТЕЛЯ.
     *
     * ⚠️ Это единственный способ узнать о таком классе: `<img>` грузит
     * браузер, ошибка не всплывает ни в один наш обработчик, и человек видит
     * значок битой картинки, о котором мы не знаем ничего. Событие шлётся
     * ОДИН раз за сессию на страницу: сорванная сеть даёт сорок таких ошибок
     * подряд, и сорок событий не скажут больше одного.
     */
    var imgFailReported = false;
    function reportImageFailure(url) {
        if (imgFailReported) return;
        imgFailReported = true;
        funnel('image_broken', { path: String(url || '').replace(/^https?:\/\/[^/]+/, '') });
    }

    function toast(msg, type) {
        if (window.__toast) window.__toast(msg, type || 'error');
    }

    /** Отказ сервера обязан быть НАЗВАН. Общее «что-то пошло не так» на
     *  восемь разных причин — это отказ, который человек не может исправить. */
    function refusalText(reason, extra) {
        var map = T.refusals || {};
        if (map[reason]) return map[reason];
        if (extra && extra.retry_after) return (map.too_fast || reason);
        return map.generic || reason;
    }

    // ────────────────────────────────────────────────────────── время ──

    var rtf = null, dtf = null, dayFmt = null;
    try {
        rtf = new Intl.RelativeTimeFormat(CFG.locale, { numeric: 'auto' });
        dtf = new Intl.DateTimeFormat(CFG.locale, { hour: '2-digit', minute: '2-digit' });
        dayFmt = new Intl.DateTimeFormat(CFG.locale, { day: 'numeric', month: 'long' });
    } catch (e) { /* очень старый движок — ниже запасной путь */ }

    function clockOf(iso) {
        var d = new Date(iso);
        if (dtf) return dtf.format(d);
        return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    /** Относительное время — только для свежего. Через сутки «вчера в 14:02»
     *  полезнее, чем «26 часов назад»: человек думает днями, а не часами. */
    function whenOf(iso) {
        var d = new Date(iso), diff = (Date.now() - d.getTime()) / 1000;
        if (!rtf || diff > 86400) return clockOf(iso);
        if (diff < 45) return T.just_now;
        if (diff < 3600) return rtf.format(-Math.round(diff / 60), 'minute');
        return rtf.format(-Math.round(diff / 3600), 'hour');
    }

    function dayKeyOf(iso) {
        var d = new Date(iso);
        return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
    }

    function dayLabelOf(iso) {
        var d = new Date(iso), today = new Date();
        var same = function (a, b) {
            return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
        };
        if (same(d, today)) return T.today;
        var y = new Date(today.getTime() - 86400000);
        if (same(d, y)) return T.yesterday;
        return dayFmt ? dayFmt.format(d) : d.toLocaleDateString();
    }

    /*
     | ⚠️ Минутного пересчёта подписей ЗДЕСЬ БОЛЬШЕ НЕТ, и это следствие
     | переезда времени в хвост пузыря (18.09.2026). Раньше в шапке реплики
     | стояло относительное «5 минут назад», и его приходилось переписывать
     | таймером. Теперь в хвосте абсолютное ЧЧ:ММ, как в любом мессенджере:
     | оно не устаревает, дату называет разделитель дня, а ширина хвоста
     | перестала скакать между «только что» и «23 часа назад».
     |
     | Убранный таймер — не микрооптимизация: он тикал, пока открыта вкладка,
     | и переписывал текст у каждой строки ленты раз в минуту вечно.
     | Относительное время осталось там, где оно и уместно, — в списке
     | участников («последний визит …»), который перерисовывается по событию.
     */

    // ────────────────────────────────────── безопасный разбор текста ──

    /**
     * Текст → узлы DOM. Ссылки становятся <a>, @имя — <span>, всё
     * остальное — текстовыми узлами.
     *
     * ⚠️ rel="ugc nofollow noopener noreferrer" и target="_blank" обязательны:
     * ссылку пишет пользователь, и без noopener открытая вкладка получает
     * доступ к window.opener нашей страницы.
     */
    function renderText(container, text) {
        var re = /(https?:\/\/[^\s<>"']+)|(@[A-Za-z0-9_.\-]{3,32})/g;
        var last = 0, m;
        while ((m = re.exec(text)) !== null) {
            if (m.index > last) container.appendChild(document.createTextNode(text.slice(last, m.index)));
            if (m[1]) {
                var a = document.createElement('a');
                a.href = m[1];
                a.textContent = m[1].length > 60 ? m[1].slice(0, 57) + '…' : m[1];
                a.target = '_blank';
                a.rel = 'ugc nofollow noopener noreferrer';
                container.appendChild(a);
            } else {
                var s = document.createElement('span');
                s.className = 'cm-mention';
                s.textContent = m[2];
                container.appendChild(s);
            }
            last = m.index + m[0].length;
        }
        if (last < text.length) container.appendChild(document.createTextNode(text.slice(last)));
    }

    // ──────────────────────────────────────────────── отрисовка строки ──

    function avatarNode(msg) {
        var d = document.createElement('div');
        d.className = 'cm-ava';
        if (msg.avatar) {
            var isVideo = /\.(webm|mp4)(\?|$)/i.test(msg.avatar);
            var el = document.createElement(isVideo ? 'video' : 'img');
            el.src = msg.avatar;
            if (isVideo) { el.muted = true; el.loop = true; el.playsInline = true; }
            else { el.alt = ''; el.loading = 'lazy'; el.decoding = 'async'; }
            d.appendChild(el);
        } else {
            d.textContent = msg.emoji || (msg.name ? msg.name.slice(0, 1).toUpperCase() : '?');
        }
        return d;
    }

    function actionButton(label, title, fn) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cm-act';
        b.textContent = label;
        b.title = title;
        b.setAttribute('aria-label', title);
        b.addEventListener('click', function (e) { e.stopPropagation(); fn(b); });
        return b;
    }

    /**
     * Одна реплика = ПУЗЫРЬ (18.09.2026).
     *
     * Было: плоская строка во всю ширину ленты. Замер на семи экранах показал
     * строку текста в 898 px на любом мониторе шире 1440 — ~130 знаков при
     * норме 45–75, — и реплику «ага», занимающую ту же строку, что абзац.
     * Стало: устоявшийся UI мессенджера. Пузырь обнимает содержимое, упирается
     * в 68ch, свои реплики уходят вправо. Имя и время переехали ВНУТРЬ пузыря:
     * заголовок над текстом стоил строки на каждой смене автора.
     *
     * ⚠️ Форма узлов — контракт со стилями И с остальным кодом: `jumpTo`,
     * `commitEdit`, `applyReacts` и стрелка вверх ищут `.cm-text`, `[data-id]`
     * и `.cm-reacts`. Переименовываешь класс — правь их в том же коммите,
     * иначе органы молча перестают работать.
     */
    function buildMessage(msg, grouped) {
        var row = document.createElement('article');
        row.className = 'cm-msg' + (grouped ? ' cm-cont' : '') +
            (msg.team ? ' cm-team' : '') + (msg.mine ? ' cm-me' : '') +
            // Хвостик и аватар — у ПОСЛЕДНЕЙ реплики серии. Пока следующая не
            // построена, последняя это эта; appendMessages снимет пометку с
            // предыдущей, когда окажется, что серия продолжилась.
            ' cm-tailed';
        row.id = 'm' + msg.id;
        row.dataset.id = msg.id;
        row.dataset.uid = msg.uid;

        row.appendChild(avatarNode(msg));

        var body = document.createElement('div');
        body.className = 'cm-body';

        var bubble = document.createElement('div');
        bubble.className = 'cm-bubble' + (msg.img ? ' cm-hasimg' : '');

        // Имя — внутри пузыря и только у чужой реплики: свою узнают по стороне.
        if (!grouped && !msg.mine) {
            var head = document.createElement('div');
            head.className = 'cm-head';
            var name;
            if (msg.url) { name = document.createElement('a'); name.href = msg.url; }
            else { name = document.createElement('span'); }
            name.className = 'cm-name';
            name.textContent = msg.name;
            head.appendChild(name);
            if (msg.team) {
                var badge = document.createElement('span');
                badge.className = 'cm-badge';
                badge.textContent = T.team;
                head.appendChild(badge);
            }
            bubble.appendChild(head);
        }

        if (msg.re) {
            var re = document.createElement('button');
            re.type = 'button';
            re.className = 'cm-re';
            var rn = document.createElement('span');
            rn.className = 'cm-re-n';
            rn.textContent = msg.re.name;
            var rt = document.createElement('span');
            rt.className = 'cm-re-t';
            rt.textContent = msg.re.text || T.deleted;
            re.appendChild(rn); re.appendChild(rt);
            re.addEventListener('click', function () { jumpTo(msg.re.id); });
            bubble.appendChild(re);
        }

        /*
         | Снимок идёт ПЕРВЫМ и на СВОЕЙ строке — как в телеграме и ватсапе:
         | сначала картинка, подпись под ней.
         |
         | ⚠️⚠️ Обёртка `cm-imgrow` обязательна. Пузырь — флекс с переносом, и
         | без неё кнопка с картинкой вставала В ОДНУ СТРОКУ с подписью:
         | иконка 96×96 оказывалась справа от текста вместо того, чтобы быть
         | картинкой сообщения (замерено 18.09.2026 на живой доске).
         | `flex:0 0 100%` у обёртки даёт свою строку, а кнопка внутри
         | по-прежнему обнимает картинку.
         */
        if (msg.img) {
            var imgRow = document.createElement('div');
            imgRow.className = 'cm-imgrow';
            var fig = document.createElement('button');
            fig.type = 'button';
            fig.className = 'cm-img';
            var im = document.createElement('img');
            im.src = msg.img.url;
            im.alt = T.image_alt;
            im.loading = 'lazy';
            im.decoding = 'async';
            // ⚠️ Единственный способ узнать, что вложение не открылось у
            // читателя: браузер грузит картинку сам, и его отказ не приходит
            // ни в один наш обработчик. Ровно этой слепоты стоила неделя
            // битых вложений (18.09.2026).
            im.addEventListener('error', function () { reportImageFailure(msg.img.url); });
            /*
             | ⚠️⚠️ Догрузившаяся картинка ВЫТАЛКИВАЕТ последнюю реплику из
             | вида. Атрибуты width/height резервируют место по пропорции, но
             | не в точности: замер 18.09.2026 на 360×740 — лента выросла с
             | 2209 до 2413 px в тот момент, когда обе картинки стали
             | `complete`, и место чтения осталось на 204 px выше конца.
             |
             | ⚠️ Прежде этого не было видно по причине, о которой стоит
             | помнить: вложения отвечали 400 и не грузились ВООБЩЕ, поэтому
             | лента не росла. Сторож раскладки был зелёным благодаря дефекту —
             | починка одного открыла второй.
             |
             | Пере-прижимаем ТОЛЬКО если человек и так стоял внизу: иначе
             | картинка, догрузившаяся в истории, утащила бы его из места, куда
             | он специально пролистал.
             */
            im.addEventListener('load', function () {
                if (state.atBottom) scrollToBottom();
            });
            // Размеры из ответа — чтобы лента не прыгала, пока картинка грузится.
            if (msg.img.w) { im.width = msg.img.w; im.height = msg.img.h; }
            fig.appendChild(im);
            fig.addEventListener('click', function () { showLightbox(msg.img.url); });
            imgRow.appendChild(fig);
            bubble.appendChild(imgRow);
        }

        if (msg.deleted || msg.hidden) {
            var gone = document.createElement('p');
            gone.className = 'cm-gone';
            gone.textContent = msg.deleted ? T.deleted : T.hidden_by_reports;
            bubble.appendChild(gone);
            if (msg.body) { // админ и автор видят, что именно снято
                var orig = document.createElement('p');
                orig.className = 'cm-text';
                orig.style.opacity = '.6';
                renderText(orig, msg.body);
                bubble.appendChild(orig);
            }
        } else if (msg.body) {
            var p = document.createElement('p');
            p.className = 'cm-text';
            renderText(p, msg.body);
            bubble.appendChild(p);
        }

        // Карточки упомянутых инструментов — ВНУТРИ пузыря, как превью ссылки
        // в телеграме. Снаружи они занимали всю ширину ленты (замер: 1004 px
        // при пузыре 519) и читались как отдельное сообщение, а не как
        // пояснение к этому.
        if (msg.tools && msg.tools.length) bubble.appendChild(toolCardsNode(msg.tools));

        bubble.appendChild(tailNode(msg));
        body.appendChild(bubble);

        if (msg.idea) {
            var tag = document.createElement('button');
            tag.type = 'button';
            tag.className = 'cm-ideatag';
            tag.appendChild(document.createTextNode(IDEA_ICON + ' ' + msg.idea.title));
            var v = document.createElement('b');
            v.textContent = ' ' + UP_ARROW + msg.idea.votes;
            tag.appendChild(v);
            tag.addEventListener('click', function () { showIdeas(); });
            body.appendChild(tag);
        }

        body.appendChild(reactionsNode(msg));
        row.appendChild(body);
        row.appendChild(actionsNode(msg));
        return row;
    }

    /**
     * Хвост пузыря: пометка правки, время, состояние отправки.
     *
     * ⚠️ Пометка правки — ЗНАЧКОМ, а не словом: «изменено» в девяти локалях
     * имеет девять длин, и хвост переставал быть предсказуемым по ширине. У
     * значка есть title и aria-label, поэтому смысл не теряется.
     */
    function tailNode(msg) {
        var tail = document.createElement('span');
        tail.className = 'cm-tail';

        if (msg.edited) {
            var ed = document.createElement('span');
            ed.className = 'cm-tail-ed';
            ed.textContent = PENCIL;
            ed.title = T.edited;
            ed.setAttribute('aria-label', T.edited);
            tail.appendChild(ed);
        }

        var time = document.createElement('span');
        time.className = 'cm-time';
        time.dataset.ts = msg.ts;
        time.textContent = clockOf(msg.ts);
        time.title = new Date(msg.ts).toLocaleString();
        tail.appendChild(time);

        // Состояние есть только у СВОЕЙ реплики: чужую доставили не нам.
        if (msg.mine) {
            var st = document.createElement('span');
            st.className = 'cm-tail-st';
            st.textContent = msg.pending ? CLOCK : CHECK;
            st.title = msg.pending ? T.sending : T.sent;
            st.setAttribute('aria-label', st.title);
            tail.appendChild(st);
        }
        return tail;
    }

    /** Карточки инструментов. Данные приходят с сервера — реестр живёт там. */
    function toolCardsNode(cards) {
        var wrap = document.createElement('div');
        wrap.className = 'cm-tools';
        cards.forEach(function (c) {
            var a = document.createElement('a');
            a.className = 'cm-tool';
            a.href = c.url;
            var ic = document.createElement('span');
            ic.className = 'cm-tool-ic';
            ic.textContent = c.icon || TOOLBOX;
            a.appendChild(ic);
            var b = document.createElement('div');
            b.className = 'cm-tool-b';
            var t = document.createElement('span');
            t.className = 'cm-tool-t';
            t.textContent = c.title;
            b.appendChild(t);
            if (c.group) {
                var g = document.createElement('span');
                g.className = 'cm-tool-g';
                g.textContent = c.group;
                b.appendChild(g);
            }
            a.appendChild(b);
            var go = document.createElement('span');
            go.className = 'cm-tool-go';
            go.textContent = RIGHT_ARROW;
            go.setAttribute('aria-hidden', 'true');
            a.appendChild(go);
            wrap.appendChild(a);
        });
        return wrap;
    }

    function reactionsNode(msg) {
        var wrap = document.createElement('div');
        wrap.className = 'cm-reacts';
        var reacts = msg.reacts || {};
        Object.keys(reacts).forEach(function (emoji) {
            var r = reacts[emoji];
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cm-react' + (r.me ? ' on' : '');
            b.appendChild(document.createTextNode(emoji));
            var n = document.createElement('b');
            n.textContent = r.n;
            b.appendChild(n);
            b.addEventListener('click', function () { react(msg.id, emoji); });
            wrap.appendChild(b);
        });
        return wrap;
    }

    function actionsNode(msg) {
        var acts = document.createElement('div');
        acts.className = 'cm-acts';
        if (msg.deleted) return acts;

        acts.appendChild(actionButton('😀', T.react, function (btn) { openReactPicker(msg.id, btn); }));
        acts.appendChild(actionButton('↩', T.reply, function () { startReply(msg); }));
        if (!msg.idea) {
            acts.appendChild(actionButton('💡', T.promote, function () { promote(msg); }));
        }
        if (msg.mine || CFG.staff) {
            acts.appendChild(actionButton('✎', T.edit, function () { startEdit(msg); }));
            acts.appendChild(actionButton('🗑️', T.remove, function () { removeMsg(msg.id); }));
        }
        if (!msg.mine) {
            acts.appendChild(actionButton('⚑', T.report, function () { report(msg.id); }));
        }
        if (CFG.staff) {
            acts.appendChild(actionButton(msg.pinned ? '📌' : '📍', msg.pinned ? T.unpin : T.pin, function () {
                post(EP.pin, { id: msg.id, on: !msg.pinned }).then(function (d) {
                    if (!d.ok) { toast(T.refusals.generic); return; }
                    msg.pinned = !msg.pinned;
                    renderPinned(d.pinned);
                });
            }));
        }
        return acts;
    }

    // ──────────────────────────────────────────────── вставка в ленту ──

    /**
     * Группировка: подряд идущие реплики одного человека в пределах пяти
     * минут не повторяют аватар и имя. Это не косметика — на телефоне так
     * помещается вдвое больше сообщений, а серия читается как одна мысль.
     */
    /**
     * Снять «последняя в серии» с реплики, за которой пришла ещё одна того же
     * автора. Хвостик пузыря и аватар остаются только у нижней — так серия
     * читается как одна мысль, а привязка к человеку стоит там, где мысль
     * кончилась (приём телеграма).
     *
     * ⚠️ Узел может оказаться разделителем дня или чертой «новое» — у них
     * класса нет, и трогать их нельзя.
     */
    function untail(node) {
        if (node && node.classList && node.classList.contains('cm-msg')) {
            node.classList.remove('cm-tailed');
        }
    }

    function appendMessages(list) {
        if (!list.length) return;
        var loading = document.getElementById('cmLoading');
        if (loading) loading.remove();

        var frag = document.createDocumentFragment();
        list.forEach(function (msg) {
            var day = dayKeyOf(msg.ts);
            if (day !== state.lastDay) {
                var sep = document.createElement('div');
                sep.className = 'cm-day';
                var span = document.createElement('span');
                span.textContent = dayLabelOf(msg.ts);
                sep.appendChild(span);
                frag.appendChild(sep);
                state.lastDay = day;
                state.lastAuthor = null;
            }
            // Черта «отсюда новое» — приём Slack и Discord: вернувшись в
            // комнату через сутки, человек не ищет глазами, где остановился.
            // Рисуется ОДИН раз и только на первой отрисовке: реплика, пришедшая
            // при тебе, новой для тебя не является.
            if (state.firstPaint && state.lastRead > 0 && msg.id > state.lastRead
                && !frag.querySelector('.cm-unread') && msg.uid !== CFG.uid) {
                var ur = document.createElement('div');
                ur.className = 'cm-unread';
                var urs = document.createElement('span');
                urs.textContent = T.unread_here;
                ur.appendChild(urs);
                frag.appendChild(ur);
                state.lastAuthor = null;
            }
            var ts = new Date(msg.ts).getTime();
            var grouped = state.lastAuthor === msg.uid && (ts - state.lastTs) < 300000 && !msg.re;
            var node = buildMessage(msg, grouped);
            if (state.lastId > 0) node.classList.add('cm-new');
            // Серия продолжилась — значит ПРЕДЫДУЩАЯ реплика уже не последняя
            // в ней: снимаем с неё хвостик и аватар. Решить это заранее нельзя
            // — «последняя в серии» известно только когда пришла следующая.
            if (grouped) untail(frag.lastElementChild || listEl.lastElementChild);
            frag.appendChild(node);
            state.lastAuthor = msg.uid;
            state.lastTs = ts;
            if (msg.id > state.lastId) state.lastId = msg.id;
            if (!state.firstId || msg.id < state.firstId) state.firstId = msg.id;
        });

        var pinned = state.atBottom;
        listEl.appendChild(frag);
        if (pinned) scrollToBottom();
        else bumpUnseen(list.filter(function (m) { return m.uid !== CFG.uid; }).length);
    }

    function replaceMessage(msg) {
        var old = listEl.querySelector('[data-id="' + msg.id + '"]');
        if (!old) return false;
        var grouped = old.classList.contains('cm-cont');
        var node = buildMessage(msg, grouped);
        old.replaceWith(node);
        return true;
    }

    function scrollToBottom(again) {
        listEl.scrollTop = listEl.scrollHeight;
        state.atBottom = true;
        state.unseen = 0;
        jumpBtn.hidden = true;
        markRead();
        // ⚠️⚠️ Одного присеста НЕ ХВАТАЕТ, и это не перестраховка. Строки ленты
        // объявлены `content-visibility:auto`, поэтому до первого кадра их
        // высота — оценка по contain-intrinsic-size, а не настоящая: замерено,
        // что после загрузки лента стояла на scrollTop=0 при 190 px хода, то
        // есть чат встречал человека САМЫМ СТАРЫМ сообщением. Заодно это
        // съедало первый поворот колеса, из-за чего страница «не прокручивалась»
        // над разговором. Досаживаем на следующих кадрах и после подгрузки
        // картинок — но только пока человек сам не увёл ленту вверх.
        if (again) return;
        requestAnimationFrame(function () {
            requestAnimationFrame(function () { if (state.atBottom) scrollToBottom(true); });
        });
        setTimeout(function () { if (state.atBottom) scrollToBottom(true); }, 320);
    }

    function bumpUnseen(n) {
        if (!n) return;
        state.unseen += n;
        document.getElementById('cmJumpN').textContent = T.jump_n.replace(':n', state.unseen);
        jumpBtn.hidden = false;
    }

    listEl.addEventListener('scroll', function () {
        var gap = listEl.scrollHeight - listEl.scrollTop - listEl.clientHeight;
        state.atBottom = gap < 60;
        if (state.atBottom) {
            state.unseen = 0;
            jumpBtn.hidden = true;
            markRead();
        }
        // Догрузка истории при подходе к верху.
        if (listEl.scrollTop < 120 && state.hasMore && !state.loading) loadOlder();
    }, { passive: true });

    jumpBtn.addEventListener('click', scrollToBottom);

    function jumpTo(id) {
        var el = listEl.querySelector('[data-id="' + id + '"]');
        if (!el) { toast(T.not_in_view, 'info'); return; }
        // block:'nearest' — единственная разрешённая форма (CLAUDE.md):
        // она ничего не делает, если элемент уже виден.
        el.scrollIntoView({ block: 'nearest' });
        el.classList.remove('cm-target');
        void el.offsetWidth;
        el.classList.add('cm-target');
    }

    // ───────────────────────────────────────────────────── загрузка ──

    function loadState() {
        state.loading = true;
        get(EP.state + boardQ('?')).then(function (d) {
            state.loading = false;
            if (!d.ok) { renderDenied(d); return; }
            state.hasMore = d.has_more;
            if (d.me) {
                state.lastRead = parseInt(d.me.last_read, 10) || 0;
                state.interests = d.me.interests || [];
            }
            appendMessages(d.messages);
            state.firstPaint = false;
            renderIdeas(d.ideas);
            renderPinned(d.pinned);
            renderWho(d.members, d.online);
            renderTags();
            scrollToBottom();
            if (!d.messages.length) renderEmpty();
            startPolling();
            // Стадии доски. «Открыл» ≠ «прочитал» ≠ «написал», и без этих
            // трёх точек нельзя ответить даже на вопрос «доска вообще живая?».
            stage('open', { msgs: d.messages.length, online: d.online || 0 });
            funnel('board_open', {
                msgs: d.messages.length,
                unread: state.lastRead ? d.messages.filter(function (m) { return m.id > state.lastRead; }).length : 0,
                w: window.innerWidth,
                imgs: d.messages.filter(function (m) { return !!m.img; }).length
            });
            // Правила спрашиваем ОДИН раз и до первого сообщения, а не после
            // отказа сервера: узнать о правиле, уже нарушив его, — плохой способ.
            if (!state.rulesOk) openRules();
        }).catch(function () {
            state.loading = false;
            renderEmpty(T.offline);
        });
    }

    function loadOlder() {
        if (!state.firstId) return;
        state.loading = true;
        var keepHeight = listEl.scrollHeight, keepTop = listEl.scrollTop;
        get(EP.state + '?before=' + state.firstId + boardQ('&')).then(function (d) {
            state.loading = false;
            if (!d.ok || !d.messages.length) { state.hasMore = false; return; }
            state.hasMore = d.has_more;
            // История вставляется СВЕРХУ, и место чтения обязано остаться на
            // месте: без этого лента прыгает под пальцем на каждой догрузке.
            var frag = document.createDocumentFragment();
            var prevAuthor = null, prevTs = 0, prevDay = '';
            d.messages.forEach(function (msg) {
                var day = dayKeyOf(msg.ts);
                if (day !== prevDay) {
                    var sep = document.createElement('div');
                    sep.className = 'cm-day';
                    var s = document.createElement('span');
                    s.textContent = dayLabelOf(msg.ts);
                    sep.appendChild(s);
                    frag.appendChild(sep);
                    prevDay = day; prevAuthor = null;
                }
                var ts = new Date(msg.ts).getTime();
                var grouped = prevAuthor === msg.uid && (ts - prevTs) < 300000 && !msg.re;
                if (grouped) untail(frag.lastElementChild);
                frag.appendChild(buildMessage(msg, grouped));
                prevAuthor = msg.uid; prevTs = ts;
                if (!state.firstId || msg.id < state.firstId) state.firstId = msg.id;
            });
            listEl.prepend(frag);
            listEl.scrollTop = keepTop + (listEl.scrollHeight - keepHeight);
        }).catch(function () { state.loading = false; });
    }

    function renderEmpty(msg) {
        if (listEl.querySelector('.cm-msg')) return;
        listEl.textContent = '';
        var box = document.createElement('div');
        box.className = 'cm-empty';
        var ic = document.createElement('div');
        ic.className = 'cm-empty-ic';
        ic.textContent = msg ? '📡' : '👋';
        var t = document.createElement('p');
        t.className = 'cm-empty-t';
        t.textContent = msg ? T.offline_title : T.empty_title;
        var d = document.createElement('p');
        d.className = 'cm-empty-d';
        d.textContent = msg || T.empty_text;
        box.appendChild(ic); box.appendChild(t); box.appendChild(d);

        // Пустой экран обязан отвечать на вопрос «а что мне тут делать».
        // Подсказанная реплика превращает его в одно нажатие и заодно
        // показывает, о чём здесь вообще говорят. ⚠️ Текст уезжает В ПОЛЕ, а
        // не отправляется сам: человек дописывает своё и остаётся автором
        // собственной фразы — подставленная за него реплика была бы чужой.
        if (!msg && Array.isArray(T.starters) && T.starters.length) {
            var st = document.createElement('div');
            st.className = 'cm-starters';
            T.starters.forEach(function (line) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'cm-starter';
                b.textContent = line;
                b.addEventListener('click', function () {
                    inputEl.value = line + ' ';
                    inputEl.focus();
                    try { inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length); } catch (e) {}
                    updateComposer();
                    autoGrow();
                });
                st.appendChild(b);
            });
            box.appendChild(st);
        }
        listEl.appendChild(box);
    }

    function renderDenied(d) {
        renderEmpty(refusalText(d.reason));
        // Отказ читающего эндпоинта при УЖЕ открытой странице — не норма:
        // гейт страницы и гейт ленты разошлись, и человек видит пустой экран
        // вместо объяснения. Без события это неотличимо от «тут пусто».
        funnel('board_denied', { reason: d.reason || 'unknown' });
    }

    /**
     * Присутствие живёт в ШАПКЕ, а не в колонке.
     *
     * Прежде «кто здесь» занимал правый рельс на треть ширины — и в комнате,
     * где идей ноль, а людей семь, это была треть экрана пустоты рядом с
     * разговором. Стопка аватаров (приём Figma и Google Docs) отвечает на тот
     * же вопрос одной строкой, а нажатие раскрывает список целиком.
     */
    function renderWho(members, online) {
        if (Array.isArray(members)) state.members = members;
        var list = state.members || [];
        var live = list.filter(function (m) { return m.online; });
        var n = typeof online === 'number' ? online : live.length;

        stackEl.textContent = '';
        // Пять аватаров — предел, после которого стопка перестаёт читаться и
        // начинает отъедать ширину у заголовка на телефоне.
        (live.length ? live : list).slice(0, 5).forEach(function (m) {
            var a = avatarNode(m);
            if (m.online) a.classList.add('on');
            stackEl.appendChild(a);
        });
        whoNEl.textContent = n > 0 ? T.online_n.replace(':n', n) : T.who_open;
        whoBtn.setAttribute('aria-label', T.who_title + ' — ' + whoNEl.textContent);
    }

    function renderPeople() {
        if (!peopleEl) return;
        peopleEl.textContent = '';
        var list = state.members || [];
        if (!list.length) {
            var e = document.createElement('p');
            e.className = 'cm-empty-d';
            e.textContent = T.who_nobody;
            peopleEl.appendChild(e);
            return;
        }
        list.forEach(function (m) {
            var row = document.createElement('div');
            row.className = 'cm-person';
            var a = avatarNode(m);
            if (m.online) a.classList.add('on');
            row.appendChild(a);

            var b = document.createElement('div');
            b.className = 'cm-person-b';
            var nm;
            if (m.url) { nm = document.createElement('a'); nm.href = m.url; }
            else { nm = document.createElement('span'); }
            nm.className = 'cm-person-n';
            nm.textContent = m.name;
            b.appendChild(nm);

            var meta = document.createElement('div');
            meta.className = 'cm-person-m';
            var when = document.createElement('span');
            when.textContent = m.online ? T.who_here : (m.seen ? T.who_seen.replace(':when', whenOf(m.seen)) : '');
            meta.appendChild(when);
            (m.interests || []).forEach(function (k) {
                var chip = document.createElement('span');
                chip.className = 'cm-chip';
                chip.textContent = (T.interests && T.interests[k]) ? T.interests[k] : k;
                meta.appendChild(chip);
            });
            b.appendChild(meta);
            row.appendChild(b);
            peopleEl.appendChild(row);
        });
    }

    /**
     * Чипы занятий. Четыре штуки, закрытый список — это ответ на вопрос «что
     * нас объединяет», а не анкета: пятый пункт превращает строку участника в
     * подпись профиля, которую некому вычитывать.
     */
    function renderTags() {
        if (!tagsEl) return;
        tagsEl.textContent = '';
        (CFG.interests || []).forEach(function (k) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cm-tag';
            b.textContent = (T.interests && T.interests[k]) ? T.interests[k] : k;
            var on = state.interests.indexOf(k) >= 0;
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.addEventListener('click', function () { toggleInterest(k, b); });
            tagsEl.appendChild(b);
        });
    }

    function toggleInterest(key, btn) {
        var i = state.interests.indexOf(key);
        if (i >= 0) state.interests.splice(i, 1); else state.interests.push(key);
        btn.setAttribute('aria-pressed', i >= 0 ? 'false' : 'true');
        post(EP.interests, { interests: state.interests }).then(function (d) {
            if (!d || !d.ok) { toast(T.refusals.generic); return; }
            state.interests = d.interests || [];
            if (d.members) { renderWho(d.members); renderPeople(); }
            renderTags();
        }).catch(function () { toast(T.refusals.network); });
    }

    function openWho() {
        renderTags();
        renderPeople();
        if (whoDlg) { try { whoDlg.showModal(); } catch (e) { whoDlg.setAttribute('open', ''); } }
    }
    function closeWho() {
        if (whoDlg) { try { whoDlg.close(); } catch (e) { whoDlg.removeAttribute('open'); } }
    }
    if (whoBtn) whoBtn.addEventListener('click', openWho);
    ['cmWhoX', 'cmWhoClose'].forEach(function (id) {
        var b = document.getElementById(id);
        if (b) b.addEventListener('click', closeWho);
    });

    function renderPinned(p) {
        if (!p || !p.body) { pinEl.hidden = true; return; }
        pinEl.hidden = false;
        pinEl.dataset.id = p.id;
        pinBody.textContent = '';
        var strong = document.createElement('b');
        strong.textContent = p.name + ': ';
        pinBody.appendChild(strong);
        renderText(pinBody, p.body);
    }

    var pinOff = document.getElementById('cmPinOff');
    if (pinOff) {
        pinOff.addEventListener('click', function () {
            post(EP.pin, { id: parseInt(pinEl.dataset.id, 10), on: false }).then(function (d) {
                if (d.ok) renderPinned(d.pinned);
            });
        });
    }

    // ───────────────────────────────────────────────────────── опрос ──

    /**
     * Опрашивает ОДНА вкладка. Это не микрооптимизация: у человека с пятью
     * открытыми вкладками сайта пять опросов каждые четыре секунды — это
     * пятикратная нагрузка на нас и пятикратный расход батареи у него,
     * ради одного и того же ответа.
     *
     * Лидер держит именованный замок navigator.locks (он отпускается САМ,
     * когда вкладку закрывают — в отличие от флага в localStorage, который
     * пришлось бы убирать вручную и терять при вылете). Ответ раздаётся
     * остальным по BroadcastChannel. Где ни того, ни другого нет — вкладка
     * опрашивает сама: доска обязана работать, а не экономить.
     */
    var bc = null;
    try { bc = new BroadcastChannel('timbrica-community'); } catch (e) { bc = null; }

    if (bc) {
        bc.onmessage = function (ev) {
            var d = ev.data;
            if (!d || d.type !== 'poll') return;
            applyPoll(d.payload, true);
        };
    }

    var pollTimer = null;
    var lastMembersAt = Date.now();

    function cadence() {
        if (document.visibilityState === 'hidden') return CFG.hidden;
        // Пока в поле есть текст, доска опрашивается часто: иначе признак «он
        // печатает» доедет до собеседника через двадцать секунд — то есть уже
        // после самого сообщения.
        if (inputEl.value.trim()) return CFG.active;
        return document.hasFocus() ? CFG.active : CFG.idle;
    }

    var pollStarted = false;
    function startPolling() {
        // ⚠️ Идемпотентно. `loadState()` зовут повторно (выход из поиска,
        // перечитка), и каждый прежний заход добавлял ВТОРОЙ цикл таймера и
        // ВТОРУЮ заявку на замок лидера — то есть доска начинала опрашивать
        // сервер вдвое чаще с каждой перечиткой, и замок, отпущенный
        // вкладкой, доставался ей же.
        if (pollStarted) return;
        pollStarted = true;

        var isLeader = false;

        function tick() {
            clearTimeout(pollTimer);
            pollTimer = setTimeout(function () {
                if (!isLeader) { tick(); return; }
                var typing = inputEl.value.trim() && (Date.now() - state.typingAt) < 6000 ? '&typing=1' : '';
                // Список участников — не на каждый тик: он меняется куда реже
                // ленты, а весит больше неё.
                var wantMembers = (Date.now() - lastMembersAt) > 30000 ? '&members=1' : '';
                if (wantMembers) lastMembersAt = Date.now();
                get(EP.poll + '?after=' + state.lastId + '&ideas=1&filter=' + state.ideaFilter + typing + wantMembers + boardQ('&'))
                    .then(function (d) {
                        if (d && d.ok) {
                            applyPoll(d, false);
                            if (bc) bc.postMessage({ type: 'poll', payload: d });
                        }
                        tick();
                    })
                    .catch(function () { tick(); });
            }, cadence());
        }

        if (navigator.locks && navigator.locks.request) {
            navigator.locks.request('timbrica-community-poll', function () {
                isLeader = true;
                // Замок держится, пока жив этот промис — то есть пока жива
                // вкладка. Отпустится сам при закрытии, и лидером станет
                // следующая, уже стоящая в очереди.
                return new Promise(function () {});
            });
            // Не-лидер тоже тикает: он ничего не запрашивает, но обязан быть
            // готов подхватить, если лидер исчезнет и замок достанется ему.
            tick();
        } else {
            isLeader = true;
            tick();
        }

        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') tick();
        });
    }

    function applyPoll(d, fromPeer) {
        // ⚠️ Пока лента занята результатами поиска, дописывать в неё новые
        // реплики нельзя: они встанут вперемешку с найденным и превратят
        // выдачу в непонятную смесь. Ничего при этом не теряется — выход из
        // поиска перечитывает ленту целиком (см. exitSearch).
        if (state.searching) {
            if (d.members || typeof d.online === 'number') renderWho(d.members, d.online);
            return;
        }
        if (d.messages && d.messages.length) {
            var fresh = d.messages.filter(function (m) { return m.id > state.lastId; });
            var updated = d.messages.filter(function (m) { return m.id <= state.lastId; });
            updated.forEach(replaceMessage);
            if (fresh.length) appendMessages(fresh);
        }
        if (d.ideas) renderIdeas(d.ideas);
        if (d.members || typeof d.online === 'number') renderWho(d.members, d.online);
        if (d.members && whoDlg && whoDlg.open) renderPeople();
        renderTyping(d.typing);
        if (fromPeer) return;
    }

    // ─────────────────────────────────────────────────────── отправка ──

    function canSend() {
        return (inputEl.value.trim().length > 0 || state.file) && !sendBtn.disabled;
    }

    function updateComposer() {
        var len = inputEl.value.length;
        var max = CFG.maxChars;
        var left = max - len;
        countEl.textContent = left < 200 ? String(left) : '';
        countEl.className = 'cm-count' + (left < 0 ? ' bad' : left < 60 ? ' warn' : '');
        sendBtn.disabled = !(inputEl.value.trim().length > 0 || state.file) || left < 0;
    }

    inputEl.addEventListener('input', function () {
        updateComposer();
        autoGrow();
        // Признак набора едет ПАРАМЕТРОМ ближайшего опроса, своего запроса у
        // него нет. Здесь только отметка «мне есть что сообщить» — не чаще раза
        // в четыре секунды, чтобы не будить опрос на каждую букву.
        if (inputEl.value.trim() && Date.now() - state.typingAt > 4000) {
            state.typingAt = Date.now();
        }
    });

    /**
     * «Кто печатает» — единственный признак, по которому в комнате на семь
     * человек видно, что ты не один. Строка занимает место ВСЕГДА: появляясь и
     * исчезая, она дёргала бы композер на каждое чужое нажатие клавиши.
     */
    function renderTyping(names) {
        if (!typingEl) return;
        if (!names || !names.length) { typingEl.textContent = ''; return; }
        typingEl.textContent = '';
        var b = document.createElement('b');
        b.textContent = names.slice(0, 2).join(', ');
        typingEl.appendChild(b);
        var tail = names.length === 1 ? T.typing_one : T.typing_many;
        typingEl.appendChild(document.createTextNode(
            ' ' + (names.length > 2 ? T.typing_more.replace(':n', names.length - 2) + ' ' : '') + tail
        ));
    }

    /**
     * Запасной автоподгон высоты. Включается ТОЛЬКО там, где браузер не умеет
     * field-sizing:content — иначе две системы дерутся за одну высоту.
     */
    var needsAutoGrow = !(window.CSS && CSS.supports && CSS.supports('field-sizing', 'content'));
    function autoGrow() {
        if (!needsAutoGrow) return;
        inputEl.style.height = 'auto';
        inputEl.style.height = Math.min(inputEl.scrollHeight, 132) + 'px';
    }

    /**
     * На сенсорном экране Enter — это ПЕРЕВОД СТРОКИ, а не отправка.
     *
     * Клавиши Shift там нет, то есть «Shift+Enter для новой строки» —
     * инструкция, которую невозможно выполнить: человек, пишущий развёрнутый
     * отчёт о проблеме, отправлял бы его первой же строкой и дописывал
     * обрывками. Отправка на телефоне — только кнопкой.
     */
    var sendsOnEnter = !window.matchMedia || !window.matchMedia('(pointer:coarse)').matches;

    inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && sendsOnEnter) {
            e.preventDefault();
            doSend();
        }
        if (e.key === 'Escape') {
            if (state.editing) cancelEdit();
            else if (state.replyTo) cancelReply();
        }
        // ↑ на пустом поле правит последнюю свою реплику — привычка из Slack,
        // Discord и Telegram: опечатку исправляют сразу, не целясь мышью в
        // кнопку размером с ноготь.
        if (e.key === 'ArrowUp' && !inputEl.value && !state.editing) {
            var mine = listEl.querySelectorAll('.cm-msg.cm-me[data-id]');
            var last = mine.length ? mine[mine.length - 1] : null;
            var txt = last ? last.querySelector('.cm-text') : null;
            if (last && txt) {
                e.preventDefault();
                // ⚠️ Раньше здесь отрезали хвост « · изменено» регуляркой по « · ». Пометка
                // правки теперь живёт в хвосте пузыря и в текст не попадает, а регулярка оставалась бы
                // ловушкой: она съедает конец любой реплики, где человек сам написал « · ».
                startEdit({ id: parseInt(last.dataset.id, 10), body: txt.textContent });
                last.scrollIntoView({ block: 'nearest' });
            }
        }
    });

    sendBtn.addEventListener('click', doSend);

    /**
     * Отправка — СРАЗУ НА ЭКРАН, ответ сервера догоняет (18.09.2026).
     *
     * Было: реплика появлялась только после ответа. На мобильном интернете с
     * приложенным снимком (до 4 МБ) это десятки секунд, в течение которых
     * происходило ровно одно наблюдаемое событие — кнопка «отправить» гасла.
     * Текст при этом оставался в поле, и выглядело это как «ничего не
     * работает»: человек жал ещё раз, ещё раз, и уходил.
     *
     * Стало как в любом мессенджере: пузырь встаёт в ленту немедленно с
     * часами в хвосте, часы сменяются галочкой, когда сервер подтвердил.
     * Не дошло — пузырь остаётся с предупреждением и КНОПКОЙ ПОВТОРА, а текст
     * возвращается доступным: потерять написанное нельзя.
     *
     * ⚠️ Идемпотентность держит `token`: повтор шлёт ТОТ ЖЕ токен, и сервер
     * (см. CommunityBoard::send) отвечает прежним сообщением, а не вторым.
     * Без этого кнопка повтора после медленного-но-успешного запроса
     * раздваивала бы реплику.
     */
    function doSend() {
        if (!canSend()) return;
        if (!state.rulesOk) { openRules(); return; }

        if (state.editing) { commitEdit(); return; }

        var body = inputEl.value.trim();
        var token = (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random());
        var file = state.file;
        var parent = state.replyTo;

        // Поле освобождается СРАЗУ: следующую мысль пишут, не дожидаясь сети.
        inputEl.value = '';
        clearFile();
        cancelReply();
        updateComposer();
        autoGrow();

        var ghost = ghostMessage(body, file, parent, token);
        state.atBottom = true;
        listEl.appendChild(ghost);
        scrollToBottom();

        deliver({ token: token, body: body, file: file, parent: parent, ghost: ghost });
    }

    /**
     * Пузырь «отправляется» — из тех же кирпичей, что настоящая реплика,
     * поэтому он не может выглядеть иначе.
     *
     * ⚠️ `id` у него отрицательный и не пересекается с серверными: настоящие
     * идут от 1, и совпадение сломало бы и `jumpTo`, и отметку прочитанного.
     */
    var ghostSeq = 0;
    function ghostMessage(body, file, parent, token) {
        var msg = {
            id: -(++ghostSeq),
            uid: CFG.uid,
            name: '',
            mine: true,
            pending: true,
            ts: new Date().toISOString(),
            body: body,
            reacts: {}
        };
        if (parent) msg.re = { id: parent.id, name: parent.name, text: parent.body };
        var node = buildMessage(msg, false);
        node.classList.add('cm-pending');
        node.dataset.token = token;
        // Снимок показываем локальной копией: ждать, пока он доедет до сервера
        // и вернётся адресом, — это и есть та пауза, ради которой всё затеяно.
        if (file) {
            var bubble = node.querySelector('.cm-bubble');
            bubble.classList.add('cm-hasimg');
            var row = document.createElement('div');
            row.className = 'cm-imgrow';
            var fig = document.createElement('span');
            fig.className = 'cm-img';
            var im = document.createElement('img');
            im.src = URL.createObjectURL(file);
            im.alt = T.image_alt;
            // Адрес объекта живёт до выгрузки страницы; отзываем, как только
            // картинка отрисована, иначе каждый отправленный снимок остаётся
            // в памяти вкладки до перезагрузки.
            im.addEventListener('load', function () { URL.revokeObjectURL(im.src); });
            fig.appendChild(im);
            row.appendChild(fig);
            // Первым ребёнком: у настоящей реплики снимок тоже идёт до текста,
            // и призрак обязан выглядеть так же — иначе он «прыгает» при
            // замене на подтверждённую.
            bubble.insertBefore(row, bubble.firstChild);
        }
        return node;
    }

    /** Один заход доставки. Повтор зовёт её же с тем же токеном. */
    function deliver(job) {
        setGhostState(job.ghost, 'pending');

        var req;
        if (job.file) {
            var fd = new FormData();
            fd.append('body', job.body);
            fd.append('token', job.token);
            if (job.parent) fd.append('parent', job.parent.id);
            fd.append('image', job.file);
            req = post(EP.send, fd, true);
        } else {
            req = post(EP.send, {
                body: job.body, token: job.token,
                parent: job.parent ? job.parent.id : null
            });
        }

        req.then(function (d) {
            if (!d.ok) {
                // Отказ СОДЕРЖАТЕЛЬНЫЙ (правила, лимит, размер) — повторять
                // нечего: ответ не изменится. Возвращаем текст в поле, чтобы
                // человек мог его поправить, и снимаем призрак.
                job.ghost.remove();
                restoreDraft(job);
                if (d.reason === 'rules_pending') { state.rulesOk = false; openRules(); }
                else toast(refusalText(d.reason, d));
                funnel('send_refused', { reason: d.reason || 'unknown' });
                return;
            }
            job.ghost.remove();
            state.atBottom = true;
            appendMessages(d.messages.filter(function (m) { return m.id > state.lastId; }));
            scrollToBottom();
            funnel('sent', { img: job.file ? 1 : 0, chars: job.body.length });
        }).catch(function () {
            // Сеть. Здесь повтор ОСМЫСЛЕН, поэтому призрак остаётся на экране
            // с кнопкой, а не исчезает вместе с написанным.
            setGhostState(job.ghost, 'failed', function () { deliver(job); });
            funnel('send_failed', {});
        }).then(function () {
            updateComposer();
        });
    }

    /** Вернуть неотправленное в поле, ничего не затирая поверх нового текста. */
    function restoreDraft(job) {
        if (!inputEl.value) {
            inputEl.value = job.body;
            autoGrow();
        }
        if (job.file) {
            state.file = job.file;
            previewImg.src = URL.createObjectURL(job.file);
            previewBox.classList.add('on');
        }
        if (job.parent) startReply(job.parent);
        updateComposer();
    }

    function setGhostState(node, st, onRetry) {
        var tail = node.querySelector('.cm-tail');
        if (!tail) return;
        var box = tail.querySelector('.cm-tail-st');
        if (!box) return;
        node.classList.toggle('cm-pending', st === 'pending');
        node.classList.toggle('cm-failed', st === 'failed');
        box.textContent = '';
        if (st === 'failed') {
            box.textContent = WARN + ' ';
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cm-retry';
            b.textContent = T.retry;
            b.addEventListener('click', function () { onRetry(); });
            box.appendChild(b);
            box.title = T.send_failed;
        } else {
            box.textContent = CLOCK;
            box.title = T.sending;
        }
        box.setAttribute('aria-label', box.title);
    }

    // ─────────────────────────────────────────────────────── ответы ──

    function startReply(msg) {
        // Ответ и правка делят одну полоску: вход в один режим гасит другой.
        if (state.editing) cancelEdit();
        state.replyTo = msg;
        replyBar.hidden = false;
        replyBar.classList.remove('cm-editing');
        replyTxt.textContent = msg.name + ': ' + (msg.body || T.image_alt).slice(0, 80);
        inputEl.focus();
    }

    function cancelReply() {
        state.replyTo = null;
        replyBar.hidden = true;
    }

    // Один крестик обслуживает оба режима полоски — иначе он молча не работал
    // бы в режиме правки, а кнопка, которая выглядит рабочей и ничего не
    // делает, хуже её отсутствия.
    document.getElementById('cmReplyX').addEventListener('click', function () {
        if (state.editing) cancelEdit(); else cancelReply();
    });

    // ─────────────────────────────────────────────────────── правка ──

    /**
     * ⚠️⚠️ Правка ОБЯЗАНА иметь видимую отмену (починено 18.09.2026).
     *
     * Было: единственный выход из режима правки — клавиша Esc, а единственная
     * подсказка о ней — строка `#cmHint`, которую `@media (pointer:coarse)`
     * скрывает ровно на телефоне. То есть человек, нажавший «изменить» с
     * телефона, оказывался заперт: клавиши Esc там нет, кнопки нет, надписи
     * нет. Выйти можно было только отправив правку или перезагрузив страницу —
     * и во втором случае потеряв набранное.
     *
     * Стало: правка занимает ТУ ЖЕ полоску, что и ответ, вместе с её крестиком.
     * Один орган, один способ выйти, видимый на любом устройстве.
     */
    function startEdit(msg) {
        state.editing = msg.id;
        // Ответ и правка — взаимоисключающие режимы одной полоски.
        state.replyTo = null;
        inputEl.value = msg.body || '';
        inputEl.focus();
        hintEl.textContent = T.editing_hint;
        replyBar.hidden = false;
        replyBar.classList.add('cm-editing');
        replyTxt.textContent = T.editing_bar;
        updateComposer();
        autoGrow();
        funnel('edit_start', {});
    }

    function cancelEdit() {
        state.editing = null;
        inputEl.value = '';
        hintEl.textContent = T.hint;
        replyBar.hidden = true;
        replyBar.classList.remove('cm-editing');
        updateComposer();
        autoGrow();
    }

    function commitEdit() {
        var id = state.editing, body = inputEl.value.trim();
        post(EP.edit, { id: id, body: body }).then(function (d) {
            if (!d.ok) { toast(refusalText(d.reason)); return; }
            var row = listEl.querySelector('[data-id="' + id + '"]');
            var el = row ? row.querySelector('.cm-text') : null;
            if (el) {
                el.textContent = '';
                renderText(el, d.body);
            }
            // Пометка правки живёт в ХВОСТЕ пузыря, а не хвостом текста:
            // дописанная в конец абзаца, она переносилась вместе с ним и
            // выглядела частью реплики.
            var tail = row ? row.querySelector('.cm-tail') : null;
            if (tail && !tail.querySelector('.cm-tail-ed')) {
                var ed = document.createElement('span');
                ed.className = 'cm-tail-ed';
                ed.textContent = PENCIL;
                ed.title = T.edited;
                ed.setAttribute('aria-label', T.edited);
                tail.insertBefore(ed, tail.firstChild);
            }
            cancelEdit();
        });
    }

    function removeMsg(id) {
        if (!window.confirm(T.confirm_delete)) return;
        post(EP.del, { id: id }).then(function (d) {
            if (!d.ok) { toast(T.refusals.generic); return; }
            var el = listEl.querySelector('[data-id="' + id + '"] .cm-body');
            if (el) {
                el.textContent = '';
                var g = document.createElement('p');
                g.className = 'cm-gone';
                g.textContent = T.deleted;
                el.appendChild(g);
            }
        });
    }

    // ────────────────────────────────────────────────────── реакции ──

    function react(id, emoji) {
        post(EP.react, { id: id, emoji: emoji }).then(function (d) {
            if (!d || !d.ok) { if (d) toast(refusalText(d.reason)); return; }
            // ⚠️ Счётчики приходят ТЕМ ЖЕ ответом. Своё «+1», нарисованное
            // вслепую, разошлось бы с чужими реакциями; а второй запрос за
            // настоящим числом (как было) удваивал задержку нажатия — до его
            // конца кнопка выглядела ненажатой.
            var row = listEl.querySelector('[data-id=\"' + id + '\"]');
            var old = row ? row.querySelector('.cm-reacts') : null;
            if (!old) return;
            old.replaceWith(reactionsNode({ id: id, reacts: d.reacts || {} }));
        }).catch(function () { toast(T.refusals.network); });
    }

    function openReactPicker(id, anchor) {
        showEmoji(function (emoji) { react(id, emoji); }, CFG.reactions, anchor);
    }

    // ────────────────────────────────────────────────────────── идеи ──

    function renderIdeas(list) {
        if (!list) return;
        ideasEl.textContent = '';
        ideaCountEl.textContent = list.length;

        // Пока идей нет — ОДНА строка подсказки, а не пустая колонка. В молодой
        // комнате идей ноль по определению, и держать под них треть экрана
        // значит показывать пустоту ровно тем, кто пришёл первым.
        var empty = !list.length && state.ideaFilter === 'open';
        ideasEl.hidden = !list.length;
        ideasHint.hidden = !!list.length;
        ideaFilterEl.hidden = empty;
        if (!list.length) {
            ideasHint.textContent = state.ideaFilter === 'open'
                ? T.ideas_empty_text
                : (T.ideas_none_here || T.ideas_empty_text);
            return;
        }

        list.forEach(function (idea) {
            var card = document.createElement('div');
            card.className = 'cm-idea';

            var vote = document.createElement('button');
            vote.type = 'button';
            vote.className = 'cm-vote' + (idea.voted ? ' on' : '');
            vote.setAttribute('aria-pressed', idea.voted ? 'true' : 'false');
            vote.setAttribute('aria-label', T.vote);
            var arrow = document.createElement('span');
            arrow.className = 'cm-vote-a';
            arrow.textContent = '▲';
            var n = document.createElement('span');
            n.className = 'cm-vote-n';
            n.textContent = idea.votes;
            vote.appendChild(arrow); vote.appendChild(n);
            vote.addEventListener('click', function (e) { e.stopPropagation(); voteIdea(idea.id, vote, n); });
            card.appendChild(vote);

            var b = document.createElement('div');
            b.className = 'cm-idea-b';
            var title = document.createElement('p');
            title.className = 'cm-idea-t';
            title.textContent = idea.title;
            b.appendChild(title);

            var meta = document.createElement('div');
            meta.className = 'cm-idea-m';
            var st = document.createElement('span');
            st.className = 'cm-st cm-st-' + idea.status;
            st.textContent = T.statuses[idea.status] || idea.status;
            meta.appendChild(st);
            if (idea.author) {
                var au = document.createElement('span');
                au.textContent = '· ' + idea.author;
                meta.appendChild(au);
            }
            b.appendChild(meta);

            if (idea.note) {
                var note = document.createElement('p');
                note.className = 'cm-idea-note';
                note.textContent = idea.note;
                b.appendChild(note);
            }

            if (CFG.staff) {
                var sel = document.createElement('select');
                sel.className = 'tc-in';
                sel.style.cssText = 'margin-top:6px;min-height:30px;font-size:12px;padding:4px 6px';
                CFG.statuses.forEach(function (s) {
                    var o = document.createElement('option');
                    o.value = s;
                    o.textContent = T.statuses[s] || s;
                    if (s === idea.status) o.selected = true;
                    sel.appendChild(o);
                });
                sel.addEventListener('click', function (e) { e.stopPropagation(); });
                sel.addEventListener('change', function () {
                    post(EP.ideaStatus, { id: idea.id, status: sel.value }).then(function (d) {
                        if (d && d.ok) { renderIdeas(d.ideas); toast(T.status_saved, 'success'); }
                        else { toast(T.refusals.generic); }
                    });
                });
                b.appendChild(sel);
            }

            card.appendChild(b);
            if (idea.msg) {
                card.addEventListener('click', function () { jumpTo(idea.msg); });
            }
            ideasEl.appendChild(card);
        });
    }

    function voteIdea(id, btn, numEl) {
        post(EP.vote, { id: id }).then(function (d) {
            if (!d.ok) return;
            numEl.textContent = d.votes;
            btn.classList.toggle('on', d.mine);
            btn.setAttribute('aria-pressed', d.mine ? 'true' : 'false');
        });
    }

    function promote(msg) {
        var suggested = (msg.body || '').replace(/\s+/g, ' ').trim().slice(0, 110);
        var title = window.prompt(T.promote_prompt, suggested);
        if (title === null) return;
        post(EP.promote, { id: msg.id, title: title }).then(function (d) {
            if (!d.ok) { toast(refusalText(d.reason)); return; }
            renderIdeas(d.ideas);
            toast(T.promoted, 'success');
            showIdeas();
        });
    }

    document.getElementById('cmIdeaFilter').addEventListener('click', function (e) {
        var b = e.target.closest('[data-f]');
        if (!b) return;
        this.querySelectorAll('.tc-seg-b').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        state.ideaFilter = b.dataset.f;
        get(EP.poll + '?after=' + state.lastId + '&ideas=1&filter=' + state.ideaFilter + boardQ('&'))
            .then(function (d) { if (d.ok) renderIdeas(d.ideas); });
    });

    // ─────────────────────────────────────────────────────── жалобы ──

    function report(id) {
        var note = window.prompt(T.report_prompt, '');
        if (note === null) return;
        post(EP.report, { id: id, reason: 'other', note: note }).then(function (d) {
            toast(d.ok ? T.reported : T.refusals.generic, d.ok ? 'success' : 'error');
        });
    }

    // ──────────────────────────────────────────────── прочитано ──

    var readTimer = null;
    function markRead() {
        clearTimeout(readTimer);
        readTimer = setTimeout(function () {
            if (!state.lastId) return;
            post(EP.read, { id: state.lastId });
        }, 900);
    }

    // Уход со страницы: досылаем отметку прочтения маячком — обычный fetch в
    // этот момент браузер вправе отменить, и значок непрочитанного остался бы
    // висеть после того, как человек всё прочитал.
    window.addEventListener('pagehide', function () {
        if (!state.lastId || !navigator.sendBeacon) return;
        var fd = new FormData();
        fd.append('id', state.lastId);
        fd.append('board', CFG.board || CFG.locale || '');
        fd.append('_token', csrf());
        navigator.sendBeacon(EP.read, fd);
    });

    // ─────────────────────────────────────────────────────── эмодзи ──

    var EMOJI = ['😀', '😄', '🙂', '😉', '😍', '🤔', '😐', '😕', '😢', '😡',
        '👍', '👎', '🙏', '👏', '🔥', '💡', '✅', '❌', '⚠️', '❤️',
        '🎉', '🚀', '🐞', '🔧', '📌', '📎', '⭐', '💬', '👀', '🤝'];

    var emojiPick = null;

    var emojiAnchor = null;

    /**
     * Открыта ли палитра в верхнем слое. Псевдокласс открытого поповера —
     * неизвестный селектор там, где Popover API нет (Chrome до 114, Firefox до
     * 125, Safari до 17): matches() бросает SyntaxError. Здесь он бросал прямо в
     * нажатии кнопки, и палитра на таком браузере не открывалась вовсе — тот же
     * класс, что дал 93 ошибки за 20 дней на /video-crop (14.10.2026).
     */
    function emojiNativeOpen() {
        try { return emojiBar.matches(':popover-open'); } catch (e) { return false; }
    }

    /**
     * ⚠️⚠️ Координаты палитры считаются ЯВНО, и это не украшательство.
     *
     * Popover центрируется ровно одним правилом браузерной таблицы стилей —
     * `inset:0` вместе с `margin:auto`. В нашем CSS стояло `margin:0`, правило
     * отменялось, и палитра уезжала в ЛЕВЫЙ ВЕРХНИЙ УГОЛ ЭКРАНА: замер дал
     * (0,0) при кнопке на (924,431) — поверх логотипа, на другом конце
     * страницы. Тот же класс, что центрирование <dialog>. Но и центр экрана
     * здесь неверен: палитра принадлежит КНОПКЕ, а не странице, поэтому она
     * встаёт над ней и прижимается к её краю.
     */
    function placeEmoji() {
        if (!emojiAnchor || !emojiNativeOpen()) return;
        var a = emojiAnchor.getBoundingClientRect();
        var w = emojiBar.offsetWidth, h = emojiBar.offsetHeight;
        var rtl = (document.documentElement.dir || '').toLowerCase() === 'rtl';
        var left = rtl ? a.left : a.right - w;
        left = Math.min(Math.max(8, left), Math.max(8, window.innerWidth - w - 8));
        // ⚠️ Прижимать надо к ОБОИМ краям. Прежняя проверка ловила только
        // «не вылезло вверх», и когда кнопка оказывалась ниже экрана (доска
        // далеко внизу страницы), палитра уезжала за нижнюю границу — на пяти
        // размерах из восьми.
        var top = a.top - h - 8;
        if (top < 8) top = a.bottom + 8;
        top = Math.min(Math.max(8, top), Math.max(8, window.innerHeight - h - 8));
        emojiBar.style.position = 'fixed';
        emojiBar.style.margin = '0';
        emojiBar.style.inset = 'auto';
        emojiBar.style.left = left + 'px';
        emojiBar.style.top = top + 'px';
    }

    function showEmoji(onPick, set, anchor) {
        emojiPick = onPick;
        emojiAnchor = anchor || emojiBtn;
        emojiGrid.textContent = '';
        (set || EMOJI).forEach(function (e) {
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = e;
            b.setAttribute('aria-label', e);
            b.addEventListener('click', function () {
                if (emojiPick) emojiPick(e);
                hideEmoji();
            });
            emojiGrid.appendChild(b);
        });
        // Popover кладёт палитру в ВЕРХНИЙ слой: она не может оказаться под
        // соседней панелью, не требует ни одного z-index и закрывается сама по
        // Esc и по нажатию мимо. Где его нет — обычный абсолютный блок у
        // композера, тот же вид, чуть менее надёжный.
        if (emojiBar.showPopover) {
            try {
                emojiBar.showPopover();
                placeEmoji();
                emojiBtn.setAttribute('aria-expanded', 'true');
                var first = emojiGrid.querySelector('button');
                if (first) first.focus();
                return;
            } catch (e) {}
        }
        emojiBar.classList.add('cm-open');
        emojiBtn.setAttribute('aria-expanded', 'true');
    }

    function hideEmoji() {
        if (emojiBar.hidePopover && emojiNativeOpen()) {
            try { emojiBar.hidePopover(); } catch (e) {}
        }
        emojiBar.classList.remove('cm-open');
        emojiBtn.setAttribute('aria-expanded', 'false');
        emojiPick = null;
        emojiAnchor = null;
    }

    // Пока палитра открыта, она обязана держаться своей кнопки: страница под
    // ней прокручивается, а верхний слой за потоком не следует.
    ['scroll', 'resize'].forEach(function (ev) {
        window.addEventListener(ev, placeEmoji, true);
    });
    // ⚠️ popover=auto закрывается САМ по нажатию мимо — и кнопка «открыть» для
    // него тоже «мимо». Поэтому к моменту нашего click палитра уже закрыта, и
    // наивная проверка «открыта ли» открывала её заново: кнопка переставала
    // закрывать. Запоминаем момент закрытия и глушим клик, который его вызвал.
    var emojiClosedAt = 0;
    emojiBar.addEventListener('toggle', function (e) {
        if (e.newState === 'closed') {
            emojiClosedAt = Date.now();
            emojiBtn.setAttribute('aria-expanded', 'false');
            emojiPick = null;
            emojiAnchor = null;
        }
    });

    document.getElementById('cmEmojiX').addEventListener('click', hideEmoji);

    // ⚠️⚠️ Состояние снимается на pointerdown, а не в обработчике click, и это
    // не перестраховка. popover=auto закрывается САМ по нажатию мимо, а кнопка
    // «открыть» для него тоже «мимо»; событие `toggle` при этом приходит
    // ОТДЕЛЬНОЙ задачей и вполне может опоздать за click. Проверено: палитра
    // открывалась заново на каждое нажатие, то есть кнопка переставала
    // закрывать вовсе. Момент pointerdown — единственная точка, где ещё видно,
    // была ли палитра открыта.
    var emojiWasOpen = false;
    emojiBtn.addEventListener('pointerdown', function () {
        emojiWasOpen = emojiNativeOpen() || emojiBar.classList.contains('cm-open');
    });

    emojiBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (emojiWasOpen || emojiNativeOpen() || emojiBar.classList.contains('cm-open')) {
            emojiWasOpen = false;
            hideEmoji();
            return;
        }
        if (Date.now() - emojiClosedAt < 60) return;
        showEmoji(function (em) {
            inputEl.value += em;
            updateComposer();
            inputEl.focus();
        }, null, emojiBtn);
    });

    document.addEventListener('click', function (e) {
        if (!emojiBar.contains(e.target) && emojiBar.classList.contains('cm-open')) hideEmoji();
    });

    // ────────────────────────────────────────────────────── картинки ──

    var pickBtn = document.getElementById('cmPick');
    if (pickBtn && fileInput) {
        pickBtn.addEventListener('click', function () { fileInput.click(); });
        fileInput.addEventListener('change', function () {
            if (fileInput.files && fileInput.files[0]) acceptFile(fileInput.files[0]);
            fileInput.value = '';
        });

        // Вставка скриншота из буфера — главный способ приложить картинку на
        // десктопе: человек жмёт PrintScreen и Ctrl+V, а не ищет файл на диске.
        // ⚠️ Слушаем ДОКУМЕНТ, а не поле: человек, только что прокрутивший
        // ленту, жмёт Ctrl+V, не думая о том, где сейчас каретка. Обработчик
        // на поле молча ничего не делал, если фокус был не в нём.
        document.addEventListener('paste', function (e) {
            if (!root.contains(document.activeElement) && document.activeElement !== document.body) return;
            var items = (e.clipboardData || {}).items || [];
            for (var i = 0; i < items.length; i++) {
                if (items[i].type && items[i].type.indexOf('image/') === 0) {
                    var f = items[i].getAsFile();
                    if (f) { e.preventDefault(); acceptFile(f); return; }
                }
            }
        });

        /*
         | Перетаскивание ловит ВСЯ ДОСКА, а не одна лента.
         |
         | ⚠️⚠️ До 18.09.2026 слушатель стоял только на `.cm-list`. Снимок,
         | брошенный на поле ввода — самую очевидную цель, — падал мимо зоны,
         | и браузер открывал файл КАК СТРАНИЦУ: доска исчезала вместе с
         | набранным текстом. Ни ошибки, ни следа; со стороны это «сайт
         | выкинул меня, когда я перетащил картинку».
         |
         | ⚠️ `dragleave` не годится как сигнал «ушёл»: он приходит на каждом
         | переходе между дочерними элементами, и накладка мигала бы. Считаем
         | вхождения счётчиком — приём известный и единственный надёжный.
         */
        var dragDepth = 0;
        var hasFiles = function (e) {
            var t = e.dataTransfer;
            if (!t) return false;
            if (t.types) for (var i = 0; i < t.types.length; i++) if (t.types[i] === 'Files') return true;
            return false;
        };
        root.addEventListener('dragenter', function (e) {
            if (!hasFiles(e)) return;
            e.preventDefault();
            if (++dragDepth === 1) root.classList.add('cm-dragging');
        });
        root.addEventListener('dragover', function (e) {
            if (!hasFiles(e)) return;
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
        });
        root.addEventListener('dragleave', function () {
            if (dragDepth > 0 && --dragDepth === 0) root.classList.remove('cm-dragging');
        });
        root.addEventListener('drop', function (e) {
            if (!hasFiles(e)) return;
            e.preventDefault();
            dragDepth = 0;
            root.classList.remove('cm-dragging');
            var f = e.dataTransfer.files[0];
            if (f) { acceptFile(f); funnel('file_dropped', {}); }
        });
    }

    /**
     * Принять файл.
     *
     * ⚠️ HEIC/HEIF (снимок с айфона) проверяется ПО ИМЕНИ тоже, а не только по
     * типу: часть браузеров отдаёт такому файлу пустой `type`, и проверка
     * «начинается ли тип с image/» его отвергала как «не картинку». Разжимает
     * его общая дверь сайта `window.HeicConvert`; её здесь может не быть
     * (скрипт не подключён на этой странице) — тогда файл идёт дальше как был,
     * и отказ придёт от сервера, но уже с понятной причиной.
     */
    function acceptFile(file) {
        var heic = /\.(heic|heif)$/i.test(file.name || '') ||
            /image\/(heic|heif)/i.test(file.type || '');
        if (!heic && (!file.type || file.type.indexOf('image/') !== 0)) {
            toast(T.refusals.image_bad_type);
            return;
        }
        (heic ? toJpeg(file) : Promise.resolve(file))
            .then(downscale)
            .then(function (blob) {
                if (blob.size > CFG.maxBytes) { toast(T.refusals.image_too_big); return; }
                state.file = new File([blob], 'shot.webp', { type: blob.type });
                previewImg.src = URL.createObjectURL(blob);
                previewBox.classList.add('on');
                updateComposer();
                funnel('file_attached', { heic: heic ? 1 : 0, kb: Math.round(blob.size / 1024) });
            })
            .catch(function () {
                toast(T.refusals.image_broken);
                funnel('file_rejected', { heic: heic ? 1 : 0 });
            });
    }

    /** HEIC → обычная картинка через общий примитив сайта. */
    function toJpeg(file) {
        if (!window.HeicConvert || !CFG.heicWorker) return Promise.resolve(file);
        try {
            var conv = window.HeicConvert.create({ workerUrl: CFG.heicWorker, heicToUrl: CFG.heicTo });
            return conv.convert(file, { format: 'image/jpeg', quality: .9 })
                .then(function (out) { return out && out.blob ? out.blob : (out || file); })
                // Не смог — отдаём исходник: отказ от картинки худший исход.
                .catch(function () { return file; });
        } catch (e) {
            return Promise.resolve(file);
        }
    }

    /**
     * Ужимаем ДО отправки. Скриншот с экрана 4K весит 6 МБ и не несёт ни
     * одного пикселя пользы сверх 2000 px по длинной стороне; отправлять его
     * целиком — это минута ожидания на мобильном интернете ради того, что
     * сервер всё равно уменьшит.
     */
    function downscale(file) {
        return createImageBitmap(file).then(function (bmp) {
            var scale = Math.min(1, CFG.maxSide / Math.max(bmp.width, bmp.height));
            var w = Math.max(1, Math.round(bmp.width * scale));
            var h = Math.max(1, Math.round(bmp.height * scale));
            var c = document.createElement('canvas');
            c.width = w; c.height = h;
            c.getContext('2d').drawImage(bmp, 0, 0, w, h);
            bmp.close && bmp.close();
            return new Promise(function (res, rej) {
                c.toBlob(function (b) { b ? res(b) : rej(new Error('encode')); }, 'image/webp', 0.82);
            });
        }).catch(function () {
            // Нет createImageBitmap или WebP — отправляем как есть, сервер
            // пересоберёт. Отказ от картинки был бы худшим исходом.
            return file;
        });
    }

    function clearFile() {
        state.file = null;
        previewBox.classList.remove('on');
        if (previewImg.src.indexOf('blob:') === 0) URL.revokeObjectURL(previewImg.src);
        previewImg.removeAttribute('src');
    }

    var pvX = document.getElementById('cmPreviewX');
    if (pvX) pvX.addEventListener('click', function () { clearFile(); updateComposer(); });

    function showLightbox(url) {
        lightboxImg.src = url;
        try { lightbox.showModal(); } catch (e) { window.open(url, '_blank', 'noopener'); }
        funnel('image_opened', {});
    }
    if (lightbox) {
        /*
         | ⚠️ Закрытие висит на клике ПО ПОДЛОЖКЕ, а не по чему угодно внутри.
         | Полоса с кнопками лежит в самом диалоге, и обработчик «клик =
         | закрыть» гасил бы окно раньше, чем срабатывала кнопка «сохранить».
         | Признак подложки — `e.target === lightbox`: у щелчка по фону цель
         | сам диалог, у щелчка по содержимому — потомок.
         */
        lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox) lightbox.close();
        });
        var lbClose = document.getElementById('cmLbClose');
        if (lbClose) lbClose.addEventListener('click', function () { lightbox.close(); });

        /*
         | Сохранить вложение.
         |
         | ⚠️⚠️ До 18.09.2026 унести приложенный скриншот было НЕЧЕМ: файл
         | лежит в закрытом хранилище и отдаётся только гейтованным адресом, а
         | «сохранить как» из контекстного меню на телефоне не существует
         | вовсе. Скачиваем через общую дверь `__downloadFile` — прямой
         | `<a download>` на кросс-адресе молча не работает в Android WebView.
         */
        var lbSave = document.getElementById('cmLbSave');
        if (lbSave) lbSave.addEventListener('click', function () {
            var url = lightboxImg.getAttribute('src');
            if (!url) return;
            lbSave.disabled = true;
            fetch(url, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) throw new Error(String(r.status));
                    return r.blob();
                })
                .then(function (blob) {
                    var name = 'timbrica-' + (url.match(/image\/(\d+)/) || [0, 'shot'])[1] + '.webp';
                    if (window.__downloadFile) window.__downloadFile(blob, name);
                    else window.open(url, '_blank', 'noopener');
                    funnel('image_saved', {});
                })
                .catch(function () { toast(T.refusals.network); })
                .then(function () { lbSave.disabled = false; });
        });
    }

    // ───────────────────────────────────────────────── поиск по доске ──

    /*
     | Зачем он есть: доска копит разбор проблем, и ценность разбора в том, что
     | его можно НАЙТИ. Без поиска единственный способ вернуться ко вчерашнему
     | обсуждению — листать ленту страницами по 40, то есть чем полезнее доска
     | становится, тем труднее ею пользоваться.
     |
     | ⚠️ Результаты рисуются В ТОЙ ЖЕ ленте, а не в отдельном списке: одна
     | разметка реплики, одни действия над ней, один способ ответить. Второй
     | рендер разошёлся бы с первым в первую же правку.
     |
     | ⚠️ Выход из поиска ПЕРЕЗАГРУЖАЕТ ленту, а не прячет её. Лента —
     | накопленное состояние (lastId, серии, черта «новое»); показать её
     | обратно, не перечитав, значит вернуть человека в позавчерашний разговор
     | и пропустить всё, что пришло, пока он искал.
     */
    var findBtn = document.getElementById('cmFindBtn');
    var findBox = document.getElementById('cmFind');
    var findQ = document.getElementById('cmFindQ');
    var findX = document.getElementById('cmFindX');
    var foundBar = document.getElementById('cmFound');
    var foundN = document.getElementById('cmFoundN');
    var foundBack = document.getElementById('cmFoundBack');
    var findTimer = null;

    function openFind() {
        if (!findBox) return;
        findBox.hidden = false;
        findQ.focus();
        funnel('search_open', {});
    }

    function closeFind() {
        if (!findBox) return;
        findBox.hidden = true;
        findQ.value = '';
        if (state.searching) exitSearch();
    }

    /** Вернуться из результатов в живой разговор — с перечиткой ленты. */
    function exitSearch() {
        state.searching = false;
        foundBar.hidden = true;
        listEl.textContent = '';
        state.lastId = 0; state.firstId = 0; state.lastDay = '';
        state.lastAuthor = null; state.lastTs = 0; state.firstPaint = true;
        loadState();
    }

    function runSearch(q) {
        if (!EP.search) return;
        state.searching = true;
        get(EP.search + '?q=' + encodeURIComponent(q) + boardQ('&')).then(function (d) {
            if (!d.ok) { toast(refusalText(d.reason, d)); return; }
            // ⚠️ Пока ответ шёл, человек мог уйти из поиска. Рисовать его
            // результаты поверх вернувшегося разговора нельзя.
            if (!state.searching) return;

            listEl.textContent = '';
            state.lastDay = '';
            state.lastAuthor = null;

            foundBar.hidden = false;
            foundN.textContent = d.messages.length
                ? (d.truncated ? T.search_found_many : T.search_found).replace(':n', d.messages.length)
                : T.search_none;

            if (!d.messages.length) { funnel('search_done', { n: 0, len: q.length }); return; }

            // Сервер отдаёт от новых к старым; читать удобнее сверху вниз по
            // времени, как в самой ленте.
            var frag = document.createDocumentFragment();
            d.messages.slice().reverse().forEach(function (msg) {
                var node = buildMessage(msg, false);
                highlight(node, q);
                frag.appendChild(node);
            });
            listEl.appendChild(frag);
            listEl.scrollTop = listEl.scrollHeight;
            funnel('search_done', { n: d.messages.length, len: q.length, more: d.truncated ? 1 : 0 });
        }).catch(function () { toast(T.refusals.network); });
    }

    /**
     * Подсветить найденное.
     *
     * ⚠️ Работаем по ТЕКСТОВЫМ УЗЛАМ, а не по innerHTML: в реплике уже стоят
     * собранные нами ссылки и упоминания, и перезапись разметки строкой их бы
     * сломала — а заодно открыла бы ровно ту дыру, которой в этом файле нет
     * нигде (см. шапку про innerHTML).
     */
    function highlight(node, q) {
        var needle = q.toLowerCase();
        node.querySelectorAll('.cm-text').forEach(function (p) {
            var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
            var texts = [], t;
            while ((t = walker.nextNode())) texts.push(t);
            texts.forEach(function (tn) {
                var hay = tn.nodeValue.toLowerCase();
                var at = hay.indexOf(needle);
                if (at < 0) return;
                var mark = document.createElement('mark');
                mark.className = 'cm-hit';
                mark.textContent = tn.nodeValue.slice(at, at + q.length);
                var after = tn.splitText(at);
                after.nodeValue = after.nodeValue.slice(q.length);
                tn.parentNode.insertBefore(mark, after);
            });
        });
    }

    if (findBtn) findBtn.addEventListener('click', function () {
        if (findBox.hidden) openFind(); else closeFind();
    });
    if (findX) findX.addEventListener('click', closeFind);
    if (foundBack) foundBack.addEventListener('click', function () {
        closeFind();
    });
    if (findQ) {
        // Задержка 320 мс: искать на каждое нажатие — это запрос на букву,
        // а порог throttle у эндпоинта 30 в минуту, то есть половина слова.
        findQ.addEventListener('input', function () {
            clearTimeout(findTimer);
            var q = findQ.value.trim();
            if (q.length < (CFG.searchMin || 2)) {
                if (state.searching) exitSearch();
                return;
            }
            findTimer = setTimeout(function () { runSearch(q); }, 320);
        });
        findQ.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { e.preventDefault(); closeFind(); }
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(findTimer);
                var q = findQ.value.trim();
                if (q.length >= (CFG.searchMin || 2)) runSearch(q);
            }
        });
    }

    // ──────────────────────────────────────── размер и высота доски ──

    /**
     * У доски нет «правильной» высоты: на 13" ноутбуке экран дорог, на 27"
     * мониторе его некуда девать. Поэтому высоту тянут за ручку, а размер
     * переключают тремя ступенями — и обе настройки помнятся.
     *
     * ⚠️ Ступень «мельче» уменьшает ОТСТУПЫ, а не буквы: 12 px — пол сайта
     * (мобильный штраф Google), и каждый множитель на шрифте в CSS обёрнут в
     * max(12px, …). Поэтому «компактно» здесь честно компактно и при этом
     * читаемо — ровно как «Clean / Compact» у Slack.
     */
    var SIZES = ['s', 'm', 'l'];
    var TS = window.__toolSettings;

    function applySize(v) {
        var i = SIZES.indexOf(v);
        if (i < 0) { v = 'm'; i = 1; }
        root.dataset.size = v;
        document.getElementById('cmSizeDown').disabled = i === 0;
        document.getElementById('cmSizeUp').disabled = i === SIZES.length - 1;
        if (TS) TS.save('chat-room', 'size', v);
    }

    function stepSize(delta) {
        var i = SIZES.indexOf(root.dataset.size || 'm');
        applySize(SIZES[Math.min(SIZES.length - 1, Math.max(0, i + delta))]);
    }

    document.getElementById('cmSizeDown').addEventListener('click', function () { stepSize(-1); });
    document.getElementById('cmSizeUp').addEventListener('click', function () { stepSize(1); });
    applySize(TS ? TS.load('chat-room', 'size', 'm') : 'm');

    // Ctrl/⌘ + колесо НАД лентой — тот же зум, только жестом. Перехватываем
    // строго над лентой и строго с модификатором: во всех остальных местах
    // страницы масштаб браузера продолжает работать как обычно.
    listEl.addEventListener('wheel', function (e) {
        if (!e.ctrlKey && !e.metaKey) return;
        e.preventDefault();
        stepSize(e.deltaY < 0 ? 1 : -1);
    }, { passive: false });

    var MIN_H = 300;
    function maxH() { return Math.max(MIN_H, Math.round(window.innerHeight * 0.92)); }

    function setHeight(px, remember) {
        var h = Math.min(maxH(), Math.max(MIN_H, Math.round(px)));
        root.style.setProperty('--cm-h', h + 'px');
        if (remember) {
            // С этой минуты высотой владеет ЧЕЛОВЕК: автоподбор (fitHeight)
            // больше не вмешивается — ни сейчас, ни при повороте телефона.
            savedH = h;
            if (TS) TS.save('chat-room', 'h', h);
        }
    }

    function resetHeight() {
        savedH = 0;
        root.style.removeProperty('--cm-h');
        if (TS) TS.save('chat-room', 'h', 0);
        // Сброс возвращает не стилевое умолчание, а ПОСЧИТАННУЮ высоту:
        // «как было» здесь означает «как подобрал бы прибор», а не «как
        // угадала таблица стилей».
        fitHeight();
    }

    /**
     * Высота по умолчанию — ИЗМЕРЕННАЯ, а не угаданная (18.09.2026).
     *
     * Было: `clamp(420px, 100svh - 320px, 760px)` в стилях. Число 320 —
     * догадка о том, сколько занято над доской, и она промахивается тем
     * сильнее, чем больше экран: на 1920×1080 доска выходила 894 px при
     * доступных 680, то есть вылезала за экран на 214 px, а на 2560×1400
     * упиралась в потолок 760 и оставляла 506 px пустоты. Замер снят на семи
     * экранах.
     *
     * Стало: считаем от того, что ДЕЙСТВИТЕЛЬНО занято. Собственная обвязка
     * доски (шапка, закреплённое, ручка, лента идей) измеряется у живого DOM
     * одним чтением, и сцене достаётся остаток экрана. Формула перестаёт
     * зависеть от того, угадали ли мы вёрстку страницы вокруг.
     *
     * ⚠️ Стилевое значение остаётся запасным путём: без JS доска обязана иметь
     * разумную высоту, а не нулевую.
     *
     * ⚠️ Сохранённая человеком высота ВСЕГДА сильнее посчитанной. Ручка — это
     * решение пользователя, и пересчёт при повороте телефона не имеет права
     * его отменять.
     */
    var FIT_FLOOR = 380;   // ниже — лента перестаёт быть лентой
    var FIT_CEIL  = 1000;  // выше — читать неудобно даже на большом мониторе

    /*
     | Обвязка меряется СЛОЖЕНИЕМ своих частей, а не как «доска минус сцена».
     |
     | ⚠️⚠️ Разница принципиальная. Вычитание даёт верный ответ только если
     | всё уже отрисовано, а лента идей и закреплённое приходят ПОСЛЕ первого
     | замера — и на узком экране подсказка идей переносится на три строки.
     | Замер 18.09.2026 на 360×740: в момент старта обвязка 199 px, после
     | отрисовки 239, и доска вылезала за экран ровно на эту разницу.
     | Сложение частей ещё и не зависит от самой высоты сцены, поэтому
     | наблюдатель размеров ниже не может закрутить обратную связь.
     */
    var CHROME_PARTS = ['.cm-top', '.cm-pin', '.cm-grip', '.cm-under'];

    function chromeHeight() {
        var total = 0;
        CHROME_PARTS.forEach(function (sel) {
            var el = root.querySelector(sel);
            if (!el || el.hidden || el.offsetParent === null) return;
            var r = el.getBoundingClientRect();
            var cs = getComputedStyle(el);
            total += r.height + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
        });
        return total;
    }

    function fitHeight() {
        if (savedH > 0) return;                     // выбор человека сильнее
        var inset = parseFloat(getComputedStyle(document.documentElement)
            .getPropertyValue('--cc-bottom-inset')) || 0;
        // 24 px — воздух под доской: впритык к краю экрана она выглядит
        // обрезанной, и непонятно, кончилась она или нет.
        var avail = window.innerHeight - chromeHeight() - inset - 24;
        var h = Math.max(FIT_FLOOR, Math.min(FIT_CEIL, Math.round(avail)));
        root.style.setProperty('--cm-h', h + 'px');
    }

    var savedH = TS ? parseInt(TS.load('chat-room', 'h', 0), 10) : 0;
    if (savedH > 0) setHeight(savedH, false);
    else fitHeight();

    // Поворот телефона и смена окна меняют ответ. ⚠️ Дребезг обязателен:
    // `resize` во время перетаскивания рамки окна приходит десятками в
    // секунду, и пересчёт на каждом — это чтение раскладки на каждом кадре.
    var fitTimer = null;
    function refit() {
        clearTimeout(fitTimer);
        fitTimer = setTimeout(function () {
            var atBottom = state.atBottom;
            fitHeight();
            if (atBottom) listEl.scrollTop = listEl.scrollHeight;
        }, 180);
    }
    window.addEventListener('resize', refit);

    /*
     | Обвязка меняется и БЕЗ смены размера окна: приходит закреплённое,
     | наполняется лента идей, подгружается шрифт. Наблюдаем ровно её части —
     | сцену не наблюдаем, иначе установка `--cm-h` вызывала бы новый замер,
     | а он новую установку.
     */
    if (window.ResizeObserver) {
        var ro = new ResizeObserver(refit);
        CHROME_PARTS.forEach(function (sel) {
            var el = root.querySelector(sel);
            if (el) ro.observe(el);
        });
    }


    if (gripEl) {
        var drag = null;
        var mainEl = root.querySelector('.cm-main');
        // ⚠️ Движение и отпускание слушает ОКНО, а не сама ручка. С захватом
        // указателя (setPointerCapture) на кнопке перетаскивание в проверке
        // браузером не давало ни одного pointermove — высота не менялась вовсе,
        // хотя клавиатурный путь работал. Окно ловит события независимо от
        // того, где оказался курсор, в том числе за пределами страницы.
        gripEl.addEventListener('pointerdown', function (e) {
            drag = { y: e.clientY, h: mainEl.getBoundingClientRect().height };
            root.classList.add('cm-resizing');
            e.preventDefault();
        });
        window.addEventListener('pointermove', function (e) {
            if (!drag) return;
            var atBottom = state.atBottom;
            setHeight(drag.h + (e.clientY - drag.y), false);
            // Лента растёт СНИЗУ: без этого при увеличении высоты место чтения
            // уезжает от последней реплики, ради которой высоту и тянут.
            if (atBottom) listEl.scrollTop = listEl.scrollHeight;
        });
        ['pointerup', 'pointercancel', 'blur'].forEach(function (ev) {
            window.addEventListener(ev, function () {
                if (!drag) return;
                drag = null;
                root.classList.remove('cm-resizing');
                setHeight(mainEl.getBoundingClientRect().height, true);
            });
        });
        // Клавиатура — не довесок: ручку, которую можно только тянуть мышью,
        // нельзя использовать ни с клавиатуры, ни экранным диктором.
        gripEl.addEventListener('keydown', function (e) {
            var cur = mainEl.getBoundingClientRect().height;
            if (e.key === 'ArrowDown') { e.preventDefault(); setHeight(cur + 40, true); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); setHeight(cur - 40, true); }
            else if (e.key === 'Home' || e.key === 'Escape') { e.preventDefault(); resetHeight(); }
        });
        gripEl.addEventListener('dblclick', resetHeight);
    }

    /** Идеи живут под разговором — «показать» значит долистать до них. */
    function showIdeas() {
        var box = root.querySelector('.cm-under');
        // block:'nearest' — единственная разрешённая форма (CLAUDE.md): она
        // ничего не делает, если блок и так виден.
        if (box) box.scrollIntoView({ block: 'nearest' });
    }

    // ───────────────────────────────────────────────────────── правила ──

    var rulesOkBtn = document.getElementById('cmRulesOk');
    if (rulesOkBtn) {
        rulesOkBtn.addEventListener('click', function () {
            post(EP.rules, {}).then(function () {
                state.rulesOk = true;
                closeRules();
                inputEl.focus();
            });
        });
    }

    // ─────────────────────────────────────────────────────────── старт ──

    updateComposer();
    loadState();

    // Открыли по ссылке из уведомления — подсветить нужное сообщение.
    if (location.hash && /^#m\d+$/.test(location.hash)) {
        var wanted = parseInt(location.hash.slice(2), 10);
        setTimeout(function () { jumpTo(wanted); }, 800);
    }
})();
